// extracted by mini-css-extract-plugin
export default {"wrap":"CardControlsBtn_wrap__k2kQj","arrow":"CardControlsBtn_arrow__YCIXJ"};